import { Component, OnInit, signal, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../shared/core/state/users/users.service';
import { StorageService } from '../../shared/util/storage.service';
import { CONST } from '../../shared/util/const';
import { catchError } from 'rxjs';

@Component({
  selector: 'black-zoom-oauth-callback',
  standalone: false,

  templateUrl: './zoom-oauth-callback.component.html',
  styleUrl: './zoom-oauth-callback.component.css',
})
export class ZoomOauthCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private userService = inject(UserService);
  private storageService = inject(StorageService);


  status = signal('Initiated..');

  ngOnInit(): void {
    const code = this.route.snapshot.queryParams['code'];
    const returnedState = this.route.snapshot.queryParams['state'];
    const redirectUrl = `${window.location.origin}/auth/zoom-callback`;

    this.storageService.get(CONST.STORAGE_KEYS.ZOOM_OAUTH_STATE).then(savedState => {
      if (!savedState || savedState !== returnedState) {
        this.status.set('Authorization failed: invalid state parameter.');
        console.error('OAuth state mismatch — possible CSRF attack');
        return;
      }
      this.storageService.remove(CONST.STORAGE_KEYS.ZOOM_OAUTH_STATE);

      this.userService.getZoomAuthToken(code, redirectUrl).subscribe({
      next: (res) => {
        console.log('Zoom auth tokens', res);

        this.status.set('Fetching zoom auth tokens..');

        this.storageService.set(
          CONST.STORAGE_KEYS.ZOOM_ACCESS_TOKEN,
          res.access_token
        );

        this.storageService.set(
          CONST.STORAGE_KEYS.ZOOM_REFRESH_TOKEN,
          res.refresh_token
        );

        this.storageService.get(
          CONST.STORAGE_KEYS.ZOOM_RETURN_URL
        ).then(returnUrl => {
          this.userService
            .linkZoomAccount(res.access_token, res.refresh_token)
            .pipe(
              catchError((err) => {
                console.error('Error linking zoom account', err);
                throw err;
              })
            )
            .subscribe({
              next: () => {
                console.log('Zoom account linked');

                this.status.set('Linking zoom account..');

                if (returnUrl && returnUrl !== '') {
                  this.router.navigate([returnUrl]);
                } else {
                  this.router.navigate(['/']);
                }
              },
              error: (err) => {
                const errorMsg =
                  err?.error?.message || 'Linking zoom account failed!..';
                this.status.set(errorMsg);
                console.error(
                  'Error during linking zoom account subscription',
                  err
                );
              },
            });
        });
      },
      error: (err) => {
        this.status.set('Fetching zoom auth tokens failed!..');
        console.error('Error getting zoom auth token', err);
      },
    });
    });
  }
}
